export default __webpack_public_path__ + "static/media/slots-hover.311d8a22.webp";